import script from "./ThemeChanger.vue?vue&type=script&lang=ts"
export * from "./ThemeChanger.vue?vue&type=script&lang=ts"

export default script